import { render, staticRenderFns } from "./OrderCancelNotice.vue?vue&type=template&id=08ee94a1&scoped=true"
import script from "./OrderCancelNotice.vue?vue&type=script&lang=js"
export * from "./OrderCancelNotice.vue?vue&type=script&lang=js"
import style0 from "./OrderCancelNotice.vue?vue&type=style&index=0&id=08ee94a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee94a1",
  null
  
)

export default component.exports